module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {

 if (availableProducts && availableProducts.parallel_server) { ;
__p += '\n  <div id="resourceContainer" class="resourceContainer">\n    <div id="parallelServerBar" class="resourceTitleBar">\n      <div class="resourceContainerLabel"><span>' +
((__t = ( i18n.computeResourcePageParallelServerLabel )) == null ? '' : __t) +
'</span></div>\n      <div class="dropdown menu-container createNewComputeResource">\n        <button id="startNewParallelServerButton" title="' +
((__t = ( i18n.createParallelServerButtonTooltip )) == null ? '' : __t) +
'" type="button" disabled="disabled" class="disabled btn startNewMatlabButton" aria-haspopup="true" aria-expanded="false">\n          <span class="icon-add"></span>\n          <span>' +
((__t = ( i18n.computeResourcePageCreateNewParallelServerLabel )) == null ? '' : __t) +
'</span>\n        </button>\n      </div>\n    </div>\n    <div class="noParallelServerMessageContainer" style="display: none;">\n      <div class="noDataMsg"><span>' +
((__t = ( i18n.computeResourcePageNoParallelServersFound )) == null ? '' : __t) +
'</span></div>\n    </div>\n    <div class="parallelServerContainer">\n      <section>\n        <ol id="parallel_server-resource-collection" class="collection collection-container">\n          <div class="progressSpinnerContainer">\n            <mw-progress-indicator type="spinner" size="small"></mw-progress-indicator>\n          </div>\n        </ol>\n      </section>\n    </div>\n  </div>\n';
 } ;
__p += '\n';

}
return __p
};
